import { useEffect } from 'react';
import styled from 'styled-components';

import { useGigyaStore } from '@ciam/gigya-api';
import { Button, EmailIcon, ErrorMessage, TextField } from '@ciam/ui';
import { useTranslation } from '@ciam/i18n';
import { FormInputController } from '@ciam/form-kit';
import { AuthForm, AuthTitleSection, pageRedirects, useLoginStore } from '@features/shared';
import { useTenureCheckForm, useTenureCheckEmail } from '@features/tenure-check';

export const TenureCheckPage = () => {
  const { t } = useTranslation(['tenure-check', 'schemas']);
  const { currentUser, clearLoginInfo } = useLoginStore();

  const {
    onSubmit,
    handleSetRootError,
    control,
    formState: { errors, isValid },
  } = useTenureCheckForm();

  const addOnGigyaServiceReady = useGigyaStore((state) => state.addOnGigyaServiceReady);
  useEffect(() => {
    addOnGigyaServiceReady({
      page: 'login',
      onLoginFn: async () => {
        await clearLoginInfo();
        await pageRedirects.proxyPage();
      },
    });
  }, [addOnGigyaServiceReady, clearLoginInfo]);

  // 재직 승인 이메일 전송
  const { executeSendTenureCheckEmail } = useTenureCheckEmail(handleSetRootError);

  const rootError = errors.root?.message;

  return (
    <>
      <AuthTitleSection title={t('title-section.title')} description={t('title-section.description')} />
      <AuthForm onSubmit={onSubmit}>
        <DisplayEmailIdBlock>
          <EmailIcon />
          <p>{currentUser.email}</p>
        </DisplayEmailIdBlock>
        <FormInputController
          name="code"
          component={TextField}
          label={t('form.fields.code.label')}
          placeholder={t('form.fields.code.placeholder')}
          control={control}
          errors={errors}
        />
        <ResendButton onClick={executeSendTenureCheckEmail}>{t('form.fields.button.resend')}</ResendButton>
        <ErrorMessage message={rootError} />
        <Button
          type="submit"
          size="m"
          buttonTheme={isValid ? 'blue' : 'white'}
          disabled={!isValid}
          aria-label={t('form.fields.button.continue')}
        >
          {t('form.fields.button.continue')}
        </Button>
      </AuthForm>
    </>
  );
};

const DisplayEmailIdBlock = styled.div`
  ${({ theme }) => theme.getFontStyle('samsung-700-14')}
  color: ${({ theme }) => theme.getColor('black')};
  background: ${({ theme }) => theme.getColor('primary', 'light')};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6rem;
  border-radius: 0.4rem;
  margin-bottom: 2.8rem;
  column-gap: 0.4rem;
`;

const ResendButton = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => theme.getFontStyle('samsung-400-14')}
  color: ${({ theme }) => theme.getColor('primary', 'default')};
  margin: -1.4rem 0 2.4rem auto;
  z-index: 1;
`;
